import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { config } from '@tools/ui/consts';
import { IconType } from '@tools/ui/dime';
import { Can, permissionStore } from '@tools/ui-stores';
import ActionUserProfile from './ActionUserProfile.component';

const Link = styled(NavLink)`
  justify-content: space-between;
  display: flex;
  padding: 0;
`;

const ActionsUserProfile: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();
  const permissionModule = permissionStore.getPermissionModules;

  return (
    <div>
      <Can I="read" this={permissionModule.Settings}>
        <Link to={'/settings'}>
          <ActionUserProfile text={t('sideContainer.actions.settings')} icon={IconType.Setting} />
        </Link>
      </Can>
      <a href={config.slack}>
        <ActionUserProfile text={t('sideContainer.actions.slack')} icon={IconType.Slack} />
      </a>
    </div>
  );
};

export default ActionsUserProfile;
